import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  AfterViewInit,
  ElementRef,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { AcopioAutocompleteComponent } from '@common/autocomplete';
import * as moment from 'moment';
import { ProductoService } from '@services/producto-service';
import { TableroNegocioService, TABLERO } from '@services/tablero-negocios-service';
import { CosechaService } from '@services/cosecha-service';
import { PosicionService, EntregaService, PreciosService } from '../../../services';
import { ChartOptions, ChartType, ChartDataSets, MultiDataSet, Chart } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { PricePipe } from '@utils/pipes';
import { DialogsService } from '@services/dialogs-service';
import { NegociosService } from '@services/negocios-service';
import { CategoriaService } from '@services/categoria-service';
import { ChipsSelectorComponent } from '@common/chips-selector';
import { ColaboradorAutocompleteComponent } from '@common/autocomplete';
import {CuentaAutocompleteComponent} from '@common/autocomplete';
import {FUENTE_NAMES} from '@services/negocios-service';
import { Subject } from 'rxjs';
import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-tablero-negocios',
  templateUrl: './tablero-negocios.component.html',
  styleUrls: ['./tablero-negocios.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TableroNegociosComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private tableroService: TableroNegocioService,
              private productoService: ProductoService,
              private cosechaService: CosechaService,
              private posicionService: PosicionService,
              private entregaService: EntregaService,
              private pricePipe: PricePipe,
              private dialogsService: DialogsService,
              private negocioService: NegociosService,
              private categoriaService: CategoriaService,
              private preciosService: PreciosService,
              private snackBar: MdSnackBar,
  ) {
    productoService.Options.takeUntil(this.destroyedSubject.asObservable()).subscribe(res => { this.productoOptions = res; });
    cosechaService.Options.takeUntil(this.destroyedSubject.asObservable()).subscribe(res => { this.cosechaOptions = res; });
    entregaService.PosicionOptions.takeUntil(this.destroyedSubject.asObservable()).subscribe(res => {
      this.entregaForw = res;
      const filtered = this.entregaForw.length ? this.entregaForw.filter(x => x.Tipo === 'Posicion') : [];
      this.pagoDiferidoExists = filtered.length ? filtered[0].hasOwnProperty('Entrega_Id') : false;
      this.entregaForw = this.formatPosiciones(this.entregaForw);
    });
    categoriaService.Options.takeUntil(this.destroyedSubject.asObservable()).subscribe( res => {this.categoriaOptions = res; });
    preciosService.getMercadosPizarra().take(1).subscribe(res => {
      this.mercadoOptions = res;
      this.setIndividualFilterOptions('mercado', this.mercadoOptions);
    });
  }

  destroyedSubject = new Subject();

  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;
  @ViewChild(AcopioAutocompleteComponent) acopioAutocomplete;
  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  @ViewChildren(ChipsSelectorComponent) chipFilters: QueryList<ChipsSelectorComponent>;
  @ViewChildren(ColaboradorAutocompleteComponent) colaboradoresAutocomplete: QueryList<ColaboradorAutocompleteComponent>;

  @ViewChild('mercadosCanvas') mercadosCanvas: ElementRef;
  mercadosChart = null;
  mercadosChartLabelHTML = '';

  productoOptions = [];
  cosechaOptions = [];
  mercadoOptions = [];

  FUENTE_NAMES = FUENTE_NAMES;

  public tablero = TABLERO;

  public showFilters = false;

  tiposOption = [];
  categoriaOptions = [];


  val_totalNegocios:number = 0;
  label_totalNegocios = 'Total Negocios';

  private pagoDiferidoExists = false;

  entregaForw: any;

  Filter = {
    tipo: null,
    fechaCreacion: {
      desde: null,
      hasta: null,
    },
    marcaTemporal: {
      desde: moment().subtract(14, 'days').toDate(),
      hasta: moment().endOf('day').toDate(),
    },
    fechaEstado: {
      desde: null,
      hasta: null
    },
    acopio: [],
    producto: [],
    cosechaId: null,
    negocio: null,
    entrega: null,
    posicion: null,
    quickComprometidas: null,
    quickOportunidades: null,
    quickFinalizadas: null,
    ResultSize: 5,
    zona: [],
    responsable: [],
    autorizante: [],
    cliente: [],
    mercado: [],
    fuente: null,
  };

  quickTotalFlag = true;

  entregaFilterOptions = [];

  FECHA = {
    CREACION_DESDE: 'CD',
    CREACION_HASTA: 'CH',
    TEMPORAL_DESDE: 'TD',
    TEMPORAL_HASTA: 'TH',
    ESTADO_DESDE: 'ED',
    ESTADO_HASTA: 'EH',
  };

  @ViewChild('creacionDesdeDatePicker') creacionDesdeDatePicker;
  @ViewChild('creacionHastaDatePicker') creacionHastaDatePicker;
  @ViewChild('temporalDesdeDatePicker') temporalDesdeDatePicker;
  @ViewChild('temporalHastaDatePicker') temporalHastaDatePicker;
  @ViewChild('estadoDesdeDatePicker') estadoDesdeDatePicker;
  @ViewChild('estadoHastaDatePicker') estadoHastaDatePicker;

  @ViewChild(CuentaAutocompleteComponent) clienteAutocomplete;

  endOfDay = moment().endOf('day').toDate();


  /** Variables de estado de charts **/

  public totalChartIsReady = false;
  public totalChartHasError = false;
  public totalChartIsEmpty = false;

  public confirmadosChartIsReady = false;
  public confirmadosChartHasError = false;
  public confirmadosChartIsEmpty = false;

  public tiposChartIsReady = false;
  public tiposChartHasError = false;
  public tiposChartIsEmpty = false;

  public productosChartIsReady = false;
  public productosChartHasError = false;
  public productosChartIsEmpty = false;

  public cosechaChartIsReady = false;
  public cosechaChartHasError = false;
  public cosechaChartIsEmpty = false;

  public acopiosChartIsReady = false;
  public acopiosChartHasError = false;
  public acopiosChartIsEmpty = false;

  public negocioChartIsReady = false;
  public negocioChartHasError = false;
  public negocioChartIsEmpty = false;

  public entregaChartIsReady = false;
  public entregaChartHasError = false;
  public entregaChartIsEmpty = false;

  public clientesChartIsReady = false;
  public clientesChartHasError = false;
  public clientesChartIsEmpty = false;

  public mercadoChartIsReady = false;
  public mercadoChartHasError = false;
  public mercadoChartIsEmpty = false;

  /** Variables Chart Confirmados **/
  /** LUEGO DE LA INTEGRACION PASA A LLAMARSE NEGOCIOS **/

  public confirmadosChartLabels = ['Oportunidades', 'Comprometidas', 'Finalizadas'];
  public confirmadosChartData: MultiDataSet = [
    [0, 0, 0]
  ];
  public confirmadosChartType: ChartType = 'doughnut';
  public confirmadosChartOptions: ChartOptions = {
    responsive: true,
    aspectRatio: 1,
    cutoutPercentage: 70,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: ((tooltipItem, data) => {
          return data.labels[tooltipItem.index] + ': ' + this.pricePipe.transform(data.datasets[0].data[tooltipItem.index], 'clamp');
        }),
        footer: ((tooltipItems, data) => {
          let total = 0;
          for (let i = 0; i < data.datasets.length; i++) {
            total += parseFloat(data.datasets[i].data.reduce((a, b) => a + b, 0));
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public confirmadosChartColors = [{
    backgroundColor: [
      'rgba(58, 129, 245, 1)',
      'rgba(75, 176, 138, 1)',
      'rgba(0, 126, 4, 1)']
  }];
  public confirmadosChartMargin = 0;
  public confimadosChartConfLabel = 0;
  public confimadosChartOportLabel = 0;
  public confimadosChartFinalLabel = 0;
  public confirmadosOverlayMargin = 0;

  /** Variables Chart Tipos **/

    // Opciones para personalizar
  public tipoChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: ((tooltipItem, data) => {
          return data.labels[tooltipItem.index] + ': ' + this.pricePipe.transform(data.datasets[0].data[tooltipItem.index], 'clamp');
        }),
        footer: ((tooltipItems, data) => {
          let total = 0;
          for (let i = 0; i < data.datasets.length; i++) {
            total += parseFloat(data.datasets[i].data.reduce((a, b) => a + b, 0));
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public tipoChartLabels = ['Orden', 'Intención', 'Aviso Genuino', 'Canje', 'Contratitos'];
  public tipoChartData: number[] = [0, 0, 0, 0, 0];
  public tipoChartType: ChartType = 'pie';
  public tipoChartItemLabel = [];
  public tipoChartColors = [
    {backgroundColor: [
      'rgba(75, 176, 138, 1)',
      'rgba(58, 129, 245, 1)',
      'rgba(255, 183, 77, 1)',
      'rgba(255, 81, 81, 1)',
      'rgba(156, 96, 236, 1)']}
  ];

  /** Variables Chart Producto **/

    // Opciones para personalizar
  public productoChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      xAxes: [{
        stacked: true,
        display: false
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          // drawBorder: false
        },
        ticks: {
          fontColor: '#565656'
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          const label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label && label !== 'relleno') {
            return label + ': ' + this.pricePipe.transform(tooltipItem.xLabel, 'clamp');
          } else {
            return '';
          }
        }),
        footer: ((tooltipItems) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length - 1; i++) {
            total += parseFloat(tooltipItems[i].xLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public productoChartLabels = ['Soja', 'Maiz', 'Trigo', 'Girasol', 'Sorgo'];
  public productoChartType: ChartType = 'horizontalBar';
  public productoChartLegend = false;
  public productoChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' },
    { data: [], label: 'relleno', stack: 'a' },
  ];

  /** Variables Chart Negocio **/

    // Opciones para personalizar
  public negocioChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: true,
          drawBorder: true
        },
        ticks: {
          beginAtZero: true,
          fontColor: '#565656',
          maxTicksLimit: 8,
          callback: function(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          fontColor: '#565656',
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.xLabel, 'clamp');
        }),
        footer: ((tooltipItems, data) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].xLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public negocioChartLabels = [];
  public negocioChartType: ChartType = 'horizontalBar';
  public negocioChartLegend = false;
  public negocioChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' }
  ];

  /** Variables Chart Cliente **/

  public clienteChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: true,
          drawBorder: true
        },
        ticks: {
          beginAtZero: true,
          fontColor: '#565656',
          maxTicksLimit: 8,
          callback: function(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          fontColor: '#565656',
          callback: function (t) {
            var maxLabelLength = 10;
            if (t.length > maxLabelLength) return t.substring(0, maxLabelLength) + '...';
            else return t;
          }
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.xLabel, 'clamp');
        }),
        footer: ((tooltipItems) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].xLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public clienteChartLabels = [];
  public clienteChartType: ChartType = 'horizontalBar';
  public clienteChartLegend = false;
  public clienteChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' },
  ];

  public fullClientesNamesAlternative = [];

  /** Variables Chart Cosecha **/

  public cosechaChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          fontColor: '#565656'
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: true,
          drawBorder: true
        },
        ticks: {
          beginAtZero: true,
          fontColor: '#565656',
          maxTicksLimit: 6,
          callback: function(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }]
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.yLabel, 'clamp');
        }),
        footer: ((tooltipItems) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].yLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public cosechaChartLabels = [];
  public cosechaChartType: ChartType = 'bar';
  public cosechaChartLegend = false;
  public cosechaChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' },
  ];

  /** Variables Chart Acopios **/

  public acopioChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: true,
          drawBorder: true
        },
        ticks: {
          beginAtZero: true,
          fontColor: '#565656',
          maxTicksLimit: 8,
          callback: function(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          fontColor: '#565656',
          callback: function (t) {
            var maxLabelLength = 10;
            if (t.length > maxLabelLength) return t.substring(0, maxLabelLength) + '...';
            else return t;
          }
        }
      }]
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.xLabel, 'clamp');
        }),
        footer: ((tooltipItems) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].xLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public acopioChartLabels = [];
  public acopioChartType: ChartType = 'horizontalBar';
  public acopioChartLegend = false;
  public acopioChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' },
  ];

  /** Variables Chart Entrega **/

  public entregaChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          fontColor: '#565656'
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: true,
          drawBorder: true,
        },
        ticks: {
          beginAtZero: true,
          fontColor: '#565656',
          maxTicksLimit: 6,
          callback: function(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }]
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.yLabel, 'clamp');
        }),
        footer: ((tooltipItems) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].yLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  public entregaChartLabels = [];
  public entregaChartType: ChartType = 'bar';
  public entregaChartLegend = false;
  public entregaChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' },
  ];

    /** Variables Chart Mercado **/

    // Opciones para personalizar
    public mercadoChartLabels = [];
    public mercadoChartData: number[] = [];
    public mercadoChartTotalValue = 0;

  public genericChartColors = [
    {backgroundColor: [
      'rgba(58, 129, 245, 0.75)',
      'rgba(58, 129, 245, 0.75)',
      'rgba(58, 129, 245, 0.75)',
      'rgba(58, 129, 245, 0.75)',
      'rgba(58, 129, 245, 0.75)']},
    {backgroundColor: [
      'rgba(75, 176, 138, 0.75)',
      'rgba(75, 176, 138, 0.75)',
      'rgba(75, 176, 138, 0.75)',
      'rgba(75, 176, 138, 0.75)',
      'rgba(75, 176, 138, 0.75)']},
    {backgroundColor: [
      'rgba(0, 126, 4, 0.75)',
      'rgba(0, 126, 4, 0.75)',
      'rgba(0, 126, 4, 0.75)',
      'rgba(0, 126, 4, 0.75)',
      'rgba(0, 126, 4, 0.75)']}
  ];


  ngOnInit() {
    this.productoService.loadOptions();
    this.cosechaService.loadOptions();
    this.entregaService.loadOptions();
    this.posicionService.loadOptions();
    this.categoriaService.loadOptions();
    //this.tiposOption = this.negocioService.getTipoSelectOptions();
    this.negocioService.$tipoOptions.takeUntil(this.destroyedSubject.asObservable()).subscribe((newTiposOptions) => {
      this.tiposOption = newTiposOptions;
    })

    // independientemente de si la busqueda se realizo nuevamente o no, los filtros deben permanecer, por lo que los levantamos del servicio si es que existen
    if (this.tableroService.dashValues.Filter !== null) {
      this.Filter = this.tableroService.dashValues.Filter;
      this.setEntregaOptions();
    }

    if (this.tableroService.dashLastUpdate !== null && (moment.duration(moment().diff(this.tableroService.dashLastUpdate)).asMinutes() < 5) && this.tableroService.dashLoaded) {
      const data = this.tableroService.dashValues;
      this.setupTotalNegocios(data.TotalNegocios);
      this.setupProductos(data.Productos);
      this.setupTiposNegocio(data.TiposNegocio);
      this.setupConfirmados(data.Confirmados);
      this.setupNegocio(data.Negocio);
      this.setupClientes(data.Clientes);
      this.setupCosechas(data.Cosecha);
      this.setupAcopios(data.Acopio);
      this.setupEntrega(data.Entrega);
      this.setupMercados(data.Mercados);
    } else {
      this.getDashboard();
    }
  }

  ngAfterViewInit() {
    this.setMargin();
  }

  ngOnDestroy() {
    this.destroyedSubject.next();
  }

  getDashboard() {
    this.getTotalNegocios();
    this.getProductos();
    this.getTiposNegocio();
    this.getConfirmados();
    this.getNegocio();
    this.getClientes();
    this.getCosechas();
    this.getAcopios();
    this.getEntrega();
    this.getMarcados();
    this.tableroService.setLastUpdate();
  }

  getTotalNegocios() {
    this.totalChartHasError = false;
    this.totalChartIsReady = false;
    this.totalChartIsEmpty = false;
    this.tableroService.getTotalNegocios(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupTotalNegocios(x);
          } else {
            this.totalChartHasError = true;
          }
        },
        () => {
          this.totalChartHasError = true;
        });
  }

  setupTotalNegocios(data) {
    if (data.Total === 0) {
      this.totalChartIsEmpty = true;
      return;
    }
    this.val_totalNegocios = data.Total;
    if (this.quickTotalFlag) {
      this.label_totalNegocios = 'Total Negocios';
    } else if (this.Filter.quickComprometidas) {
      this.label_totalNegocios = 'Total Comprometidas';
    } else if (this.Filter.quickOportunidades) {
      this.label_totalNegocios = 'Total Oportunidades';
    } else {
      this.label_totalNegocios = 'Total Finalizadas';
    }
    this.totalChartIsReady = true;
  }

  getConfirmados() {
    this.confirmadosChartHasError = false;
    this.confirmadosChartIsReady = false;
    this.confirmadosChartIsEmpty = false;
    this.tableroService.getDashConfirmados(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupConfirmados(x);
          } else {
            this.confirmadosChartHasError = true;
          }
        },
        () => {
          this.confirmadosChartHasError = true;
        });
  }

  setupConfirmados(data) {
    if (data.Total === 0) {
      this.confirmadosChartIsEmpty = true;
      return;
    }
    this.confirmadosChartData[0][0] = data.Oportunidades;
    this.confirmadosChartData[0][1] = data.Comprometidas;
    this.confirmadosChartData[0][2] = data.Finalizadas;
    // this.confirmadosChartInnerText = Math.round((data.Confirmadas * 100) / (data.Confirmadas + data.Oportunidades + 0.01)).toString() + '%';
    // pasamos la data por la pipe de precio para obtener los puntos separadores
    this.confimadosChartConfLabel = this.pricePipe.transform(data.Comprometidas, 'clamp');
    this.confimadosChartOportLabel = this.pricePipe.transform(data.Oportunidades, 'clamp');
    this.confimadosChartFinalLabel = this.pricePipe.transform(data.Finalizadas, 'clamp');
    this.confirmadosChartIsReady = true;
    this.refreshChartValues();
    this.setMargin();
  }

  getTiposNegocio() {
    this.tiposChartHasError = false;
    this.tiposChartIsReady = false;
    this.tiposChartIsEmpty = false;
    this.tableroService.getDashTiposNegocio(this.Filter)
      .take(1)
      .subscribe(x => {

          if (x) {
            this.setupTiposNegocio(x);
          } else {
            this.tiposChartHasError = true;
          }
        },
        () => {
          this.tiposChartHasError = true;
        });
  }

  setupTiposNegocio(data) {
    this.tipoChartData = [0, 0, 0, 0, 0];
    if (data.length) {
      let total = 0;
      data.forEach((e) => {
        const totalItem = e.Comprometidas + e.Oportunidades + e.Finalizadas;
        total += totalItem;
        if (e.TipoNegocio === 'Orden') {
          this.tipoChartData[0] = totalItem;
        } else if (e.TipoNegocio === 'Intencion') {
          this.tipoChartData[1] = totalItem;
        } else if (e.TipoNegocio === 'Aviso Genuino') {
          this.tipoChartData[2] = totalItem;
        } else if (e.TipoNegocio === 'Canje') {
          this.tipoChartData[3] = totalItem;
        } else if (e.TipoNegocio === 'Contratito') {
          this.tipoChartData[4] = totalItem;
        }
      });

      this.tipoChartItemLabel = [];
      this.tipoChartData.forEach((y, i) => {
        this.tipoChartItemLabel.push({
          color: this.tipoChartColors[0].backgroundColor[i],
          name: this.tipoChartLabels[i],
          percentage: Math.round((y * 100) / (total + 0.01)).toString() + '%',
          value: this.pricePipe.transform(y, 'clamp')
        });
      });
    } else {
      this.tiposChartIsEmpty = true;
      return;
    }

    this.tiposChartIsReady = true;
    this.refreshChartValues();
    this.setMargin();
  }

  getProductos() {
    this.productosChartIsReady = false;
    this.productosChartHasError = false;
    this.productosChartIsEmpty = false;
    this.tableroService.getDashProductos(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupProductos(x);
          } else {
            this.productosChartHasError = true;
          }
        },
        () => {
          this.productosChartHasError = true;
        });
  }

  setupProductos(data) {
    this.productoChartData[0].data.length = 0;
    this.productoChartData[1].data.length = 0;
    this.productoChartData[2].data.length = 0;
    this.productoChartData[3].data.length = 0;
    this.productoChartLabels.length = 0;
    if (data.length) {

      // para poner los valores al 100% debemos entrontrar el dataset con mas cantidad y elevarlo en un 10%
      // el valor del dataset 'relleno' es lo que le falta a cada dataset para llenar ese valor maximo

      let biggerValue = 0;
      data.map((y) => {
        biggerValue = (y.Oportunidades + y.Comprometidas + y.Finalizadas) > biggerValue ? (y.Oportunidades + y.Comprometidas + y.Finalizadas) : biggerValue;
        this.productoChartLabels.push(y.Producto);
      });

      biggerValue = biggerValue > 0 ? Math.round(biggerValue * 1.10) : 10;

      for (let i = 0; i < this.productoChartLabels.length; i++) {
        const index = data.findIndex(item => item.Producto === this.productoChartLabels[i]);
        this.productoChartData[0].data.push(data[index].Oportunidades);
        this.productoChartData[1].data.push(data[index].Comprometidas);
        this.productoChartData[2].data.push(data[index].Finalizadas);
        this.productoChartData[3].data.push(biggerValue - (data[index].Oportunidades + data[index].Comprometidas + data[index].Finalizadas));
      }
    } else {
      this.productosChartIsEmpty = true;
      return;
    }
    this.productosChartIsReady = true;
    this.refreshChartValues();
  }

  getNegocio() {
    this.negocioChartIsReady = false;
    this.negocioChartHasError = false;
    this.negocioChartIsEmpty = false;
    this.tableroService.getDashNegocio(this.Filter)
      .take(1)
      .subscribe(x => {

          if (x) {
            this.setupNegocio(x);
          } else {
            this.negocioChartHasError = true;
          }
        },
        () => {
          this.negocioChartHasError = true;
        });
  }

  setupNegocio(data) {
    this.negocioChartData[0].data.length = 0;
    this.negocioChartData[1].data.length = 0;
    this.negocioChartData[2].data.length = 0;
    this.negocioChartLabels.length = 0;

    if (data.length) {

      data.forEach((e) => {
        this.negocioChartLabels.push(e.TipoEntrega);
        this.negocioChartData[0].data.push(e.Oportunidades);
        this.negocioChartData[1].data.push(e.Comprometidas);
        this.negocioChartData[2].data.push(e.Finalizadas);
      });
    } else {
      this.negocioChartIsEmpty = true;
      return;
    }
    this.negocioChartIsReady = true;
    this.refreshChartValues();
  }

  getClientes() {
    this.clientesChartIsReady = false;
    this.clientesChartHasError = false;
    this.clientesChartIsEmpty = false;
    this.tableroService.getDashClientes(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupClientes(x);
          } else {
            this.clientesChartHasError = true;
          }
        },
        () => {
          this.clientesChartHasError = true;
        });
  }

  setupClientes(data) {
    this.clienteChartData[0].data.length = 0;
    this.clienteChartData[1].data.length = 0;
    this.clienteChartData[2].data.length = 0;
    this.clienteChartLabels.length = 0;
    if (data.length) {
      data.map(y => { this.clienteChartLabels.push(y.Cliente); });
      data.map(y => { this.fullClientesNamesAlternative.push(y.Cliente); });

      for (let i = 0; i < this.clienteChartLabels.length; i++) {
        const index = data.findIndex(item => item.Cliente === this.clienteChartLabels[i]);
        this.clienteChartData[0].data.push(data[index].Oportunidades);
        this.clienteChartData[1].data.push(data[index].Comprometidas);
        this.clienteChartData[2].data.push(data[index].Finalizadas);
      }
    } else {
      this.clientesChartIsEmpty = true;
      return;
    }
    this.clientesChartIsReady = true;
    this.refreshChartValues();
  }

  getCosechas() {
    this.cosechaChartIsReady = false;
    this.cosechaChartHasError = false;
    this.cosechaChartIsEmpty = false;
    this.tableroService.getDashCosecha(this.Filter)
      .take(1)
      .subscribe(x => {
        if (x) {
          this.setupCosechas(x);
        } else {
          this.cosechaChartHasError = true;
        }
      },
        () => {
          this.cosechaChartHasError = true;
        });
  }

  setupCosechas(data) {
    this.cosechaChartData[0].data.length = 0;
    this.cosechaChartData[1].data.length = 0;
    this.cosechaChartData[2].data.length = 0;
    this.cosechaChartLabels.length = 0;
    if (data.length) {
      data.forEach(item => {
        this.cosechaChartLabels.push(item.Cosecha);
        this.cosechaChartData[0].data.push(item.Oportunidades);
        this.cosechaChartData[1].data.push(item.Comprometidas);
        this.cosechaChartData[2].data.push(item.Finalizadas);
      });
    } else {
      this.cosechaChartIsEmpty = true;
      return;
    }
    this.cosechaChartIsReady = true;
    this.refreshChartValues();
  }

  getAcopios() {
    this.acopiosChartIsReady = false;
    this.acopiosChartHasError = false;
    this.acopiosChartIsEmpty = false;
    this.tableroService.getDashAcopio(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupAcopios(x);
          } else {
            this.acopiosChartHasError = true;
          }
        },
        () => {
          this.acopiosChartHasError = true;
        });
  }

  setupAcopios(data) {
    this.acopioChartData[0].data.length = 0;
    this.acopioChartData[1].data.length = 0;
    this.acopioChartData[2].data.length = 0;
    this.acopioChartLabels.length = 0;

    if (data.length) {
      this.acopioChartData[1].data.length = 0;
      this.acopioChartData[0].data.length = 0;
      this.acopioChartData[2].data.length = 0;
      this.acopioChartLabels.length = 0;
      data.forEach(item => {
        this.acopioChartLabels.push(item.Acopio);
        this.acopioChartData[0].data.push(item.Oportunidades);
        this.acopioChartData[1].data.push(item.Comprometidas);
        this.acopioChartData[2].data.push(item.Finalizadas);
      });
    } else {
      this.acopiosChartIsEmpty = true;
      return;
    }
    this.acopiosChartIsReady = true;
    this.refreshChartValues();
  }

  getEntrega() {
    this.entregaChartIsReady = false;
    this.entregaChartHasError = false;
    this.entregaChartIsEmpty = false;
    this.tableroService.getDashEntrega(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupEntrega(x);
          } else {
            this.entregaChartHasError = true;
          }
        },
        () => {
          this.entregaChartHasError = true;
        });
  }

  setupEntrega(data) {
    this.entregaChartData[0].data.length = 0;
    this.entregaChartData[1].data.length = 0;
    this.entregaChartData[2].data.length = 0;
    this.entregaChartLabels.length = 0;
    if (data.length) {
      data.forEach(item => {
        this.entregaChartLabels.push(item.TipoPosicion.charAt(0).toUpperCase() + item.TipoPosicion.slice(1));
        this.entregaChartData[0].data.push(item.Oportunidades);
        this.entregaChartData[1].data.push(item.Comprometidas);
        this.entregaChartData[2].data.push(item.Finalizadas);
      });
    } else {
      this.entregaChartIsEmpty = true;
      return;
    }
    this.entregaChartIsReady = true;
    this.refreshChartValues();
  }

  getMarcados() {
    this.mercadoChartHasError = false;
    this.mercadoChartIsReady = false;
    this.mercadoChartIsEmpty = false;
    this.tableroService.getDashMercados(this.Filter)
      .take(1)
      .subscribe(x => {
          if (x) {
            this.setupMercados(x);
          } else {
            this.mercadoChartHasError = true;
          }
        },
        () => {
          this.mercadoChartHasError = true;
        });
  }

  setupMercados(data) {
    this.mercadoChartData = [];
    this.mercadoChartLabels = [];
    if (data.length) {
      this.mercadoChartTotalValue = 0;
      data.forEach((e) => {
        this.mercadoChartTotalValue +=  e.Total;
        this.mercadoChartData.push(e.Total);
        this.mercadoChartLabels.push(e.Nombre);
      });

      this.mercadoChartIsReady = true;

      setTimeout(() => {
        const ctx = (this.mercadosCanvas.nativeElement as HTMLCanvasElement).getContext('2d');
        const that = this;
        this.mercadosChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: data.map(x => x.Nombre),
            datasets: [{
              data: data.map(x => x.Total),
              backgroundColor: [ 'rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(255, 159, 64)', 'rgb(255, 205, 86)',
                'rgb(75, 192, 192)', 'rgb(153, 102, 255)', 'rgb(201, 203, 207)'],
              backgroundColorName: [ 'red', 'blue', 'orange', 'yellow', 'green', 'purple', 'grey' ]
            }],
          },
          options: {
            legend: {
              display: false
            },
            legendCallback: function(mainChart) {
              const renderLabels = (chart) => {
                return chart.data.datasets[0].data.map((_, i) =>
                  `<li>
                    <div id="legend-${i}-item" class="legend-item">
                      <i class="zmdi zmdi-circle margin-right-16 ${chart.data.datasets[0].backgroundColorName[i]}"></i>
                      <p>
                        <span class="label">
                          ${chart.data.labels[i].toString().replace('Pizarra ', '')}: $${Math.round((chart.data.datasets[0].data[i] * 100) /
                            (that.mercadoChartTotalValue + 0.01)).toString() + '%'}
                        </span><br>
                        <span class="label">
                          <strong>${that.pricePipe.transform(chart.data.datasets[0].data[i], 'clamp')}</strong> Tn
                        </span>
                      </p>
                    </div>
                  </li>`
                ).join('');
              };
              return `<ul class="chartjs-legend">${renderLabels(mainChart)}</ul>`;
            },
          }
        });
        this.mercadosChartLabelHTML = this.mercadosChart.generateLegend();
        this.refreshChartValues();
        this.setMargin();
      });
    } else {
      this.mercadoChartIsEmpty = true;
      return;
    }
  }

  /** Utilizar si los cambios de valores en un chart no se actualizan o si se cambian los Label de un chart**/
  refreshChartValues() {
    const that = this;
    setTimeout(() => {
      that.charts.forEach((child: BaseChartDirective) => {
        if (child.chart) {
          child.chart.update();
          child.chart.resize();
        }
      });
    });
  }

  filNegocioChanged(event) {
    this.checkFiltersIntegrity(event.value);
  }

  checkFiltersIntegrity(negSelected = null) {
    if (negSelected === null) {
      this.Filter.entrega = null;
      this.Filter.posicion = null;
    } else if (negSelected === 'D') {
      this.Filter.entrega = null;
      this.Filter.posicion = false;
    } else if (negSelected === 'F' || negSelected === 'P') {
      this.Filter.entrega = null;
      this.Filter.posicion = true;
    }
    this.setEntregaOptions();
  }

  onCleanFilters(event?) {
    this.hideFilters();
    this.resetFilter();
    this.tableroService.dashValues.Filter = null;
    this.getDashboard();
  }

  onApplyFilters(event) {
    event.stopPropagation();
    this.Filter.acopio = this.acopioAutocomplete.selectedAcopios;
    this.hideFilters();
    this.tableroService.dashValues.Filter = this.Filter;
    this.getDashboard();
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  public hideFilters() {
    this.showFilters = false;
  }

  // el array entregaForw debe poseer el mismo formato de objeto de entregaDisp
  formatPosiciones(posiciones) {
    if (!posiciones.length) {
      return [];
    }

    let arrTemp = [];
    if (this.pagoDiferidoExists) {
      posiciones.filter(x => x.Tipo === 'Posicion').forEach(x => arrTemp.push({Pos: x.Posicion, ID: x.ID_POS, IsPagoDiferido: x.Entrega_Id === 4}));
    } else {
      posiciones.filter(x => x.Tipo === 'Posicion').forEach(x => arrTemp.push({Pos: x.Posicion, ID: x.ID_POS, IsPagoDiferido: null}));
      arrTemp.forEach(item => {
        if (isNaN(item.Pos.charAt(0))) {
          const list = item.Pos.split('-');
          item.Pos = list[0].substring(0, 3).toUpperCase() + '-' + list[1];
        }
      });
    }

    return arrTemp;
  }

  // showDatePicker(datePicker) {
  //   if (datePicker === 'start') {
  //     this.startDatePicker.open();
  //   }else if (datePicker === 'end') {
  //     this.endDatePicker.open();
  //   }
  // }

  showDatePicker(picker) {
    switch (picker) {
      case this.FECHA.CREACION_DESDE:
        this.creacionDesdeDatePicker.open();
        break;
      case this.FECHA.CREACION_HASTA:
        this.creacionHastaDatePicker.open();
        break;
      case this.FECHA.TEMPORAL_DESDE:
        this.temporalDesdeDatePicker.open();
        break;
      case this.FECHA.TEMPORAL_HASTA:
        this.temporalHastaDatePicker.open();
        break;
      case this.FECHA.ESTADO_DESDE:
        this.estadoDesdeDatePicker.open();
        break;
      case this.FECHA.ESTADO_HASTA:
        this.estadoHastaDatePicker.open();
        break;
    }
  }

  clearDateFilter(filter) {
    // al menos uno de los filtros de modificacion o creacion debe estar activos
    let filtersOn = 0;
    filtersOn += this.Filter.fechaCreacion.desde === null ? 0 : 1;
    filtersOn += this.Filter.marcaTemporal.desde === null ? 0 : 1;
    if (filtersOn <= 1 && filter !== this.FECHA.ESTADO_DESDE) {
      this.snackBar.open('El filtro de Creación o Modificación deben tener valores', 'Aceptar', {duration: 4000});
      return;
    }
    switch (filter) {
      case this.FECHA.CREACION_DESDE:
        this.Filter.fechaCreacion = {
          desde: null,
          hasta: null,
        };
        break;
      case this.FECHA.TEMPORAL_DESDE:
        this.Filter.marcaTemporal = {
          desde: null,
          hasta: null,
        };
        break;
      case this.FECHA.ESTADO_DESDE:
        this.Filter.fechaEstado = {
          desde: null,
          hasta: null,
        };
        break;
    }
  }

  selectedDate(e, entity) {
    // Normalizamos las fechas para evitar errores de inconsistencia
    const desde = entity === this.FECHA.CREACION_DESDE || entity === this.FECHA.TEMPORAL_DESDE || entity === this.FECHA.ESTADO_DESDE;
    if (entity === this.FECHA.CREACION_DESDE || entity === this.FECHA.CREACION_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.Filter.fechaCreacion.desde, desde ? this.Filter.fechaCreacion.hasta : e);
      this.Filter.fechaCreacion.desde = dates.desde;
      this.Filter.fechaCreacion.hasta = dates.hasta;
    } else if (entity === this.FECHA.TEMPORAL_DESDE || entity === this.FECHA.TEMPORAL_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.Filter.marcaTemporal.desde, desde ? this.Filter.marcaTemporal.hasta : e);
      this.Filter.marcaTemporal.desde = dates.desde;
      this.Filter.marcaTemporal.hasta = dates.hasta;
    } else if (entity === this.FECHA.ESTADO_DESDE || entity === this.FECHA.ESTADO_HASTA) {
      const dates = this.normalizeDate(desde, desde ? e : this.Filter.fechaEstado.desde, desde ? this.Filter.fechaEstado.hasta : e);
      this.Filter.fechaEstado.desde = dates.desde;
      this.Filter.fechaEstado.hasta = dates.hasta;
    }
  }

  normalizeDate(isDesde, desde, hasta) {
    let retDesde = desde != null ? moment(desde).startOf('day').toDate() : null;
    let retHasta = hasta != null ? moment(hasta).endOf('day').toDate() : null;
    if (isDesde) {
      if (hasta === null) {
        retHasta = moment().endOf('day').toDate();
      } else {
        if (retDesde > hasta) {
          retHasta = moment(retDesde).endOf('day').toDate();
        }
      }
    } else {
      if (desde === null) {
        retDesde = moment(retHasta).startOf('day').toDate();
      } else {
        if (retHasta < desde) {
          retDesde = moment(retHasta).startOf('day').toDate();
        }
      }
    }
    return {desde: retDesde, hasta: retHasta};
  }

  quickFilterChanged(e) {
    if (e.source.name === 'QF_tot') {
      this.Filter.quickComprometidas = false;
      this.Filter.quickOportunidades = false;
      this.Filter.quickFinalizadas = false;
    } else if (e.source.name === 'QF_com') {
      this.quickTotalFlag = false;
      this.Filter.quickOportunidades = false;
      this.Filter.quickFinalizadas = false;
    } else if (e.source.name === 'QF_opo') {
      this.quickTotalFlag = false;
      this.Filter.quickComprometidas = false;
      this.Filter.quickFinalizadas = false;
    } else if (e.source.name === 'QF_fin') {
      this.quickTotalFlag = false;
      this.Filter.quickComprometidas = false;
      this.Filter.quickOportunidades = false;
    }
  }

  // el grafico dougnut no se puede centrar verticalmente de forma automatica, se usa este metodo para encontrar el
  // margen vertical para centrarlo
  // si se agregan mas resoluciones restar la resolucion menos 1 para evitar divisiones entre 0
  setMargin() {
    if (window.innerWidth >= 1200 && window.innerWidth <= 1920) {
      // optimizado para resoluciones de 1200 a 1920 de ancho: max 105px (1200) min 45 px (1920)
      // 45 px de recorrido de margen 720px de recorrido de pantalla = 1 pixel margin cada 16 de ancho
      this.confirmadosChartMargin = 85 - Math.trunc((window.innerWidth - 1199) / 10.746);

      this.confirmadosOverlayMargin = 146 - Math.trunc((window.innerWidth - 1199) / 102.857);
    } else {
      this.confirmadosChartMargin = 0;
    }
  }

  openExpandedChartDialog(tablero, isVertical) {
    this.dialogsService.showExpandedChartDialog(tablero, this.Filter, isVertical)
      .take(1).subscribe(res => {});
  }

  resetFilter() {
    this.Filter = {
      tipo: null,
      fechaCreacion: {
        desde: null,
        hasta: null,
      },
      marcaTemporal: {
        desde: moment().subtract(14, 'days').toDate(),
        hasta: moment().endOf('day').toDate(),
      },
      fechaEstado: {
        desde: null,
        hasta: null
      },
      acopio: [],
      producto: [],
      cosechaId: null,
      negocio: null,
      entrega: null,
      posicion: null,
      quickComprometidas: null,
      quickOportunidades: null,
      quickFinalizadas: null,
      ResultSize: 5,
      zona: [],
      responsable: [],
      autorizante: [],
      cliente: [],
      mercado: [],
      fuente: null,
    };
    this.acopioAutocomplete.selectedAcopios.length = 0;
    this.chipFilters.forEach(x => {
      x.unselectAllOptions();
    });
  }

  chipSelectorInitialized(filterType) {
    if (filterType === 'producto') {
      this.productoService.Options.take(1).subscribe(res => {
        this.setIndividualFilterOptions(filterType, res);
      });
    }
    if (filterType === 'mercado') {
      // TO DO
    }
    if (filterType === 'zona') {
      this.categoriaService.Options.take(1).subscribe(res => {
        this.setIndividualFilterOptions(filterType, res)
      });
    }
  }


  setIndividualFilterOptions(filterType, options) {
    if (!options.length) {
      return;
    }
    setTimeout(() => {
      let object = [];
      switch (filterType) {
        case 'producto':
          object = options.map(x => ({
            ID: x.ID,
            ItemLabel: x.Producto
          }));
          break;
        case 'zona':
          object = options.map(x => ({
            ID: x.ID,
            ItemLabel: x.Categoria
          }));
          break;
        case 'mercado':
          object = options.map(x => ({
            ID: x.Id,
            ItemLabel: x.Mercado
          }));
          break;
      }

      this.chipFilters.forEach(filter => {
        if (filter.Type === filterType) {
          const selected = this.Filter[filterType].length ? this.Filter[filterType] : null;
          filter.optionsChange(object, selected);
        }
      });
    });
  }

  setEntregaOptions() {
    if (this.Filter.negocio !== null) {
      if (this.Filter.negocio === 'D') {
        this.entregaFilterOptions = [{Id: 1, entrega: 'Entregado'}, {Id: 2, entrega: 'A Entregar'}];
      } else if (this.Filter.negocio === 'F') {
        this.entregaFilterOptions = this.entregaForw.filter(x => !x.IsPagoDiferido).map(x => ({Id: x.ID, entrega: x.Pos}));
      } else if (this.Filter.negocio === 'P') {
        this.entregaFilterOptions = this.entregaForw.filter(x => x.IsPagoDiferido).map(x => ({Id: x.ID, entrega: x.Pos}));
      }
    }
  }

  chipFilterChanged(e) {
    this.Filter[e.Type] = e.SelectedIds;
  }

  setupAcopioFilter() {
    if (this.Filter.acopio.length) {
      this.acopioAutocomplete.selection = this.Filter.acopio;
    }
  }

  colaboradoresSelected(type) {
    this.colaboradoresAutocomplete.forEach(col => {
      if (col.type === type) {
        if (type === 'resp') {
          this.Filter.responsable = col.selectedColaboradores;
        } else if (type === 'auto') {
          this.Filter.autorizante = col.selectedColaboradores;
        }
      }
    });
  }

  clienteSelected() {
    this.Filter.cliente = this.clienteAutocomplete.selectedCuentas;
  }

  fillClienteFilter() {
    this.clienteAutocomplete.selectedCuentas = this.Filter.cliente;
  }

  fillColaboradoresFilter(type) {
    this.colaboradoresAutocomplete.forEach(col => {
      if (col && col.type === type) {
        if (type === 'resp') {
          col.selectedColaboradores = this.Filter.responsable;
        } else if (type === 'auto') {
          col.selectedColaboradores = this.Filter.autorizante;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/tablero-negocios/tablero-negocios.component.ts